import React, {useRef, useEffect} from 'react'
import {useLocation} from 'react-router'
import { AsideMenuItem } from './AsideMenuItem'
import {
  DrawerComponent,
  MenuComponent,
  ScrollComponent,
  ToggleComponent,
} from '../../../assets/ts/components'
import { useAuth } from '../../../../app/components/AuthProvider'

const AsideMenu: React.FC = () => {
  const scrollRef = useRef<HTMLDivElement | null>(null)
  const {pathname} = useLocation()

  const { user: { client_pending_approvals_web} } = useAuth()

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
      DrawerComponent.reinitialization()
      ToggleComponent.reinitialization()
      ScrollComponent.reinitialization()
      if (scrollRef.current) {
        scrollRef.current.scrollTop = 0
      }
    }, 50)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  return (
    <div
      ref={scrollRef}
      className='hover-scroll-overlay-y mt-5 mb-5 mt-lg-0 mb-lg-5 pe-lg-n2 me-lg-2'
      id='kt_docs_aside_menu_wrapper'
      data-kt-scroll='true'
      data-kt-scroll-activate='{default: false, lg: true}'
      data-kt-scroll-height='auto'
      data-kt-scroll-dependencies='#kt_docs_aside_logo'
      data-kt-scroll-wrappers='#kt_docs_aside_menu'
      data-kt-scroll-offset='10px'
    >
      <div
        id='#kt_docs_aside_menu'
        data-kt-menu='true'
        className='menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500'
      >
        <AsideMenuItem to="/dashboard" title="Dashboard" />
        <AsideMenuItem to="/track" title="Track" />
        <AsideMenuItem to="/requests" title="Requests" />
        <AsideMenuItem to="/request/add" title="Add Request" />
        <AsideMenuItem to="/pending-approvals" title="Pending Approvals" badge={client_pending_approvals_web} />
        <AsideMenuItem to="/approved-worklogs" title="Approved Worklogs" />
      </div>
    </div>
  )
}

export {AsideMenu}
